function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#214080;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M65.8,23.22H34.26v-9H65.8ZM87.85,81c0,1.32-2,4.11-3.84,4.11l-68,0c-2.14,0-3.75-2.38-3.75-4V29.73H87.76ZM71.39,23.41V8.57H28.8V23.41h-23V80.14c0,6.21,4.75,11.29,10.63,11.29H83.61c5.82,0,10.57-5.61,10.57-11.89V23.41Z"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "33.92 54.19 33.92 62.28 47.32 62.28 47.32 75.43 55.31 75.43 55.31 62.28 68.77 62.28 68.77 54.19 55.31 54.19 55.31 40.7 47.32 40.7 47.32 54.19 33.92 54.19"
});

var SvgHnIconsHealthcheckBlue = function SvgHnIconsHealthcheckBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHnIconsHealthcheckBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HN_icons_Health check-Blue.04fbed17.svg";
export { ForwardRef as ReactComponent };